import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import pcImage from "../../assets/images/edu/pc.png";
import "./ChatBot8.css";

const ChatBot9 = ({ selectedConsultant, clearMessages, onClear })  => {
    const [messages, setMessages] = useState([]);
    const [input, setInput] = useState("");
    const responseBoxRef = useRef(null);
  
    const sendMessage = async () => {
      if (!input.trim()) return;
  
      const userMessage = { sender: "User", text: input };
      setMessages((prev) => [...prev, userMessage]);
  
      try {
        const chatboturl = "https://buildstart.au/chat";
        const chatboturllocal = "http://localhost:8000/chat";

        const response = await axios.post(chatboturl, {
          query: input,
          type: selectedConsultant.type, // Dynamically use the selected type
        });
  
        const botMessage = { sender: selectedConsultant.name, text: response.data.response };
        setMessages((prev) => [...prev, botMessage]);
      } catch (error) {
        console.error("Error fetching chatbot response:", error);
        const botMessage = { sender: selectedConsultant.name, text: "Error retrieving response." };
        setMessages((prev) => [...prev, botMessage]);
      }
  
      setInput(""); // Clear input field
    };
  
    const scrollToBottom = () => {
      if (responseBoxRef.current) {
        responseBoxRef.current.scrollTop = responseBoxRef.current.scrollHeight;
      }
    };
  
    useEffect(() => {
      scrollToBottom();
    }, [messages]);


      // Clear messages when clearMessages is true
      useEffect(() => {
        if (clearMessages) {
            setMessages([]);
            onClear(); // Reset the clear state in the parent component
        }
      }, [clearMessages, onClear]);
  
    return (
      <div className="chatbot-container">
        <div className="chat-title-row">
          <h2>AI {selectedConsultant.name} Chat</h2>
        </div>
  
        {/* Main Content: Profile Card & Chat Window */}
        <div className="chat-content">
          {/* Dynamic Profile Card */}
          <div className="profile-card">
            <img src={selectedConsultant.img} alt="Profile" className="profile-pic" />
            <p className="profile-text">
              Hi, I'm your personal <b>{selectedConsultant.name}!</b> {selectedConsultant.description}
            </p>
          </div>
  
          {/* Chat Window */}
          <div className="chat-container">
            <div className="chat-box" ref={responseBoxRef}>
              {messages.map((msg, index) => (
                <div key={index} className={`chat-message ${msg.sender === "User" ? "user" : "bot"}`}>
                  <span className="chat-sender">{msg.sender}:</span>
                  <div className="chat-bubble">{msg.text}</div>
                </div>
              ))}
            </div>
  
            {/* Chat Input */}
            <div className="chat-input-container">
              <input
                type="text"
                value={input}
                onChange={(e) => setInput(e.target.value)}
                onKeyPress={(e) => e.key === "Enter" && sendMessage()}
                className="chat-input"
                placeholder="Type a message..."
              />
              <button onClick={sendMessage} className="chat-send-button">Send</button>
            </div>
          </div>
        </div>
      </div>
    );
  };
  
  export default ChatBot9;